'use strict';

var ModalTemplate = "<div id=\"videoModal\" class=\"video-modal modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"videoModal\">\n                            <div class=\"modal-dialog modal-lg\" role=\"document\">\n                                <div class=\"modal-content\">\n                                    <div class=\"modal-header\">\n                                        <h5 class=\"modal-title\" aria-label=\"Video Modal\"></h5>\n                                        <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\">\n                                            <span aria-hidden=\"true\">&times;</span>\n                                        </button>\n                                    </div>\n                                    <div class=\"modal-body\"></div>\n                                </div>\n                            </div>\n                        </div>";
var ModalStates = {
  NOT_READY: 0,
  READY: 1,
  OPEN: 2,
  CLOSED: 3
};
module.exports = function () {
  var myState = ModalStates.NOT_READY;
  var currentVideo = '';
  if (!$('#videoModal').length) {
    $(ModalTemplate).appendTo('body');
    myState = ModalStates.READY;
  }
  var $modal = $('#videoModal');
  return {
    States: ModalStates,
    launch: function launch(player) {
      //test if modal is already in use
      if (myState === ModalStates.OPEN) {
        console.error('Cannot launch' + player.id + ', Modal is already in use for: ' + currentVideo);
      } else {
        $modal.on('show.bs.modal', function () {
          if (typeof player.getShowEventHandler === 'function') {
            player.getShowEventHandler();
          }
          myState = ModalStates.OPEN;
          currentVideo = player.id;
        }).on('shown.bs.modal', function () {
          if (typeof player.getShownEventHandler === 'function') {
            player.getShownEventHandler();
          }
        }).on('hide.bs.modal', function () {
          if (typeof player.getHideEventHandler === 'function') {
            player.getHideEventHandler();
          }
          myState = ModalStates.CLOSED;
        }).on('hidden.bs.modal', function () {
          if (typeof player.getHiddenEventHandler === 'function') {
            player.getHiddenEventHandler();
          }
          $modal.modal('dispose');
        }).modal();
      }
    },
    setState: function setState(state) {
      if (ModalStates[state]) {
        myState = state;
      }
    },
    getState: function getState() {
      return myState;
    },
    is: function is(state) {
      return myState === state;
    },
    getModalObj: function getModalObj() {
      return $modal;
    }
  };
}();